<style scoped lang="less">
@box-padding: 12px;
@head-height: 32px;
@icon-size: 20px;
@icon-gap: 8px;
@font-size: 16px;
.container{
  flex: 1;
  background: #fff;
  box-sizing: border-box;
  padding: @box-padding;
  margin-bottom: 12px;
  &__top{
    height: @head-height;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    &__left{
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      &__icon{
        width: @icon-size;
        height: @icon-size;
        flex-shrink: 0;
        margin-right: @icon-gap;
      }
      &__title{
        color: #141B27;
        font-family: PingFang SC;
        font-size: @font-size;
        padding-bottom: 2px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }
    &__right{
      flex: 1;
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-end;
    }
  }
}
</style>
<script>


export default {
  name: "container",
  props: {
    icon: { type:String },
    title: { type:String }
  }

}
</script>
<template>
  <div class="container">
    <div class="container__top">
      <div class="container__top__left">
        <img v-if="$props.icon" :src="$props.icon" alt="" class="container__top__left__icon">
        <div v-if="$props.title" class="container__top__left__title">{{$props.title}}</div>
      </div>
      <div class="container__top__right">
      </div>
    </div>
    <slot name="head"></slot>
    <slot name="default"></slot>
  </div>
</template>

